module.exports = __webpack_public_path__ + "img/ppt.8413a081.png";